import { FC, ReactNode, useEffect, useState, } from "react";
import { ProInput, ProSpin, } from '../antd';
import MenuTree from '../MenuTree';
import { OptionsType, SuperMenuTreeProps } from "./interface";
import { filterOption } from "./utils";

/** 快捷菜单 */
const SuperMenuTree: FC<SuperMenuTreeProps> = props => {
  const {
    collapsed: outCollapsed, options, search, loading, searchClassName, searchStyle, searchInputProps, loadingTip,
    onCollapse, ...restProps
  } = props;
  const [collapsed, setCollapsed] = useState<boolean>(outCollapsed || false);
  const [searchValue, setSearchValue] = useState<string>();
  useEffect(() => {
    setCollapsed(outCollapsed || false)
  }, [outCollapsed]);
  /** 搜索 */
  const handleSearch = (value: string) => {
    setSearchValue(value);
  };
  /** 展开-收起回调 */
  const handleCollapse = (newCollapsed: boolean) => {
    setCollapsed(newCollapsed);
    onCollapse?.(newCollapsed);
  };
  const renderMenu = (newOption: OptionsType[]) => {
    return newOption.map(item => {
      const { children, value, ...restItem } = item;
      if (Array.isArray(children)) {
        return (
          <MenuTree.SubMenu key={value} value={value} {...restItem}>
            {
              children.map(v => {
                if (Array.isArray(v.children) && v.children.length) {
                  return (
                    <MenuTree.SubMenu key={v.value} {...v}>
                      {renderMenu(v.children)}
                    </MenuTree.SubMenu>
                  )
                }
                return (
                  <MenuTree.Item key={v.value} {...v} />
                );
              })
            }
          </MenuTree.SubMenu>
        );
      }
      return (
        <MenuTree.Item key={value} value={value} {...restItem} />
      );
    });
  };
  const renderChildren = (): ReactNode => {
    if (!options) return null;
    let newOption = options;
    if (search && searchValue) {
      newOption = filterOption(options, searchValue)
    }
    return renderMenu(newOption);
  };
  if ((!options || !options.length) && !loading) {
    return (
      <div className="flex-center-center" style={{width: '100%', height: 50, color: '#6c757d'}}>
        暂无数据
      </div>
    );
  }
  return (
    <>
      {
        search ? (
          <div style={{width: '100%', ...searchStyle, ...(collapsed ? {width: 32} : undefined) }} className={searchClassName}>
            {
              !collapsed && (
                <ProInput.Search
                  placeholder="请输入"
                  onSearch={handleSearch}
                  style={{ width: '100%', marginBottom: 15, }}
                  allowClear
                  {...searchInputProps}
                />
              )
            }
            <ProSpin spinning={loading} tip={loadingTip}>
              <MenuTree
                border
                collapsed={collapsed}
                onCollapse={handleCollapse}
                {...restProps}
                style={loading ? {...restProps.style, minHeight: 100} : restProps.style}
              >
                {renderChildren()}
              </MenuTree>
            </ProSpin>
          </div>
        ) : (
          <ProSpin spinning={loading} tip={loadingTip}>
            <MenuTree
              {...restProps}
              collapsed={collapsed}
              style={loading ? {...restProps.style, minHeight: 100} : restProps.style}
              onCollapse={handleCollapse}
            >
              {renderChildren()}
            </MenuTree>
          </ProSpin>
        )
      }
    </>
  );
};

SuperMenuTree.defaultProps = {
  loading: false,
};

export default SuperMenuTree;
